export const aggregateCardStatistics = (
    tournaments,
    cards,
    archetypeFilter = null,
    filterDate = null
  ) => {
    const aggregatedCards = { oshi: [], main: [], cheers: [] };
  
    const cardMap = {};
    cards.forEach((card) => {
      cardMap[card.id] = card;
    });
  
    const parseDateFromYYYYMMDD = (dateString) => {
      const year = parseInt(dateString.slice(0, 4), 10);
      const month = parseInt(dateString.slice(4, 6), 10) - 1;
      const day = parseInt(dateString.slice(6, 8), 10);
      return new Date(year, month, day);
    };
  
    // Filter tournaments based on date range and archetype
    const filteredDecks = tournaments
      .filter((tournament) =>
        filterDate ? parseDateFromYYYYMMDD(tournament.date) >= filterDate : true
      )
      .flatMap((tournament) => tournament.decklists || [])
      .filter((deck) =>
        archetypeFilter ? deck.archetype === archetypeFilter : true
      );
  
    const totalDecks = filteredDecks.length;
  
    filteredDecks.forEach((deck) => {
      const uniqueCardIds = new Set();
  
      if (deck.oshi) {
        const [cardId] = deck.oshi.split("_");
        if (!uniqueCardIds.has(cardId)) {
          uniqueCardIds.add(cardId);
          const card = cardMap[cardId];
          if (card) {
            aggregatedCards.oshi.push({ ...card, count: 1 });
          }
        }
      }
  
      ["main", "cheers"].forEach((key) => {
        deck[key]?.forEach((cardEntry) => {
          const [rawCardId, quantity] = Object.entries(cardEntry)[0];
          const [cardId] = rawCardId.split("_");
          if (!uniqueCardIds.has(cardId)) {
            uniqueCardIds.add(cardId);
            const card = cardMap[cardId];
            if (card) {
              aggregatedCards[key].push({ ...card, count: quantity });
            }
          }
        });
      });
    });
  
    const computeCardStats = (cards) => {
      const cardStatsMap = {};
      cards.forEach((card) => {
        if (!cardStatsMap[card.id]) {
          cardStatsMap[card.id] = { ...card, total: 0, uniqueDecks: 0 };
        }
        cardStatsMap[card.id].total += card.count;
        cardStatsMap[card.id].uniqueDecks++;
      });
  
      return Object.values(cardStatsMap)
        .map((card) => ({
          ...card,
          average: (card.total / card.uniqueDecks).toFixed(2),
          percentage: ((card.uniqueDecks / totalDecks) * 100).toFixed(2),
        }))
        .sort((a, b) => b.percentage - a.percentage);
    };
  
    return {
      oshi: computeCardStats(aggregatedCards.oshi),
      main: computeCardStats(aggregatedCards.main),
      cheers: computeCardStats(aggregatedCards.cheers),
    };
  };  